module.exports = __webpack_public_path__ + "static/wcag-1065c696d120ef6e5dc939a49e643428.png";